import type { DailyBenefitRewardBundle } from '../api.js';

export function rewardDisplayName(bundle: DailyBenefitRewardBundle): string {
  const tools: Record<string, string> = { time_freeze: '冻鲜时钟', cat_rescue: '猫爪救援', carrier_clear: '整单速收', carrier_cell_cut: '单格维修' };
  return bundle.items.map(item => item.type === 'tool_entitlement'
    ? `${tools[item.toolId] ?? '道具'}×${item.count}`
    : `${item.type === 'fish_dry' ? '鱼干币' : '体力'}×${item.amount}`).join(' + ').slice(0, 64);
}

export function orderedReleaseKeys(keys: string[]): string[] {
  return [...new Set(keys.filter(Boolean))].sort((a, b) => b.localeCompare(a, 'en', { numeric: true }));
}
